import React from 'react';
import { Button } from '@ihsm/ui-shared';
import refreshIcon from 'shared/assets/icons/refresh.svg';
import { useReloadFromSFTP } from '../../hooks';
import './ReloadButton.scss';

export const ReloadButton: React.FC = () => {
  const { reload: onReload } = useReloadFromSFTP();

  return (
    <div className="reload-button">
      <Button
        text="Reload from SFTP"
        onClick={onReload}
        iconSrc={refreshIcon}
        customClass="reload-from-sftp"
      />
    </div>
  );
};
